import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SapLogoComponent} from './sap-logo.component';
import {ConfigModule} from '@spartacus/core';
import {GenericLinkModule, MediaModule} from '@spartacus/storefront';

@NgModule({
  declarations: [
    SapLogoComponent
  ],
  imports: [
    CommonModule,
    GenericLinkModule,
    MediaModule,
    ConfigModule.withConfig({
      cmsComponents: {
        BannerComponent: {
          component: SapLogoComponent
        }
      }
    })
  ],
  exports: [
    SapLogoComponent
  ]
})
export class SapLogoModule {
}
